<form [formGroup]="form">
  <div class="p-field">
    <kodit-checkbox
      [formCtrl]="form.controls.barkodSkener"
      labelText="Pretraga artikala sa bar kod čitačem"
    ></kodit-checkbox>
  </div>

  <div class="p-field">
    <kodit-checkbox
      [formCtrl]="form.controls.stampanje"
      labelText="Štampanje računa nakon fiskalizacije"
    ></kodit-checkbox>
  </div>

  <div class="p-fluid">
    <kodit-field
      fieldLabel="Veličina papira za fiskalni račun">
      <kodit-velicina-papira-dropdown
        [formCtrl]="form.controls.velicinaPapiraDto.get('velicinaPapira')"
        formCtrlId="velicina-papira"
      ></kodit-velicina-papira-dropdown>
    </kodit-field>

    <kodit-field
        fieldLabel="Popust za fiskalni račun"
        fieldLabelFor="prikaz-rabata"
      >
        <kodit-prikaz-rabata-dropdown
          formCtrlId="prikaz-rabata"
          [formCtrl]="form.controls.prikazRabataDto.get('prikazRabata')"
        ></kodit-prikaz-rabata-dropdown>
      </kodit-field>

    <kodit-field
      fieldLabel="Akcija nakon fiskalizacije"
      fieldLabelFor="post-akcija-fiskalizacije"
    >
      <kodit-post-akcija-fiskalizacija-dropdown
        [formCtrl]="form.controls.postFiskalizacijeAkcijaDto.get('postFiskalizacijeAkcija')"
        formCtrlId="post-akcija-fiskalizacije"
      ></kodit-post-akcija-fiskalizacija-dropdown>
    </kodit-field>
  </div>

</form>
